/**
 * LIST-BUTTON
 * Little button with icon
 */
import { IconDefinition } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { connect } from "react-redux"
import { useState } from "react"
import ActionsMenu from "./actions-menu"
import { Session } from "@/redux/_session.types"
import Tooltip from "./tooltip"

interface StateProps {
  _session: Session
}

interface ActionState {
  icon: IconDefinition
  id: string
  isInactive?: boolean
  label: string
}

interface OwnProps {
  actions?: ActionState[] //If defined, open a context menu with actions
  actionsPositionBottom?: boolean //Context menu from bottom (default from top)
  color?: string //Color for the button
  dot?: boolean //Show dot
  dotColor?: string //color of the dot
  dotOffsetY?: number //Vertical adjustment of the dot in pixels
  text?: string //Text for tooltip
  tooltipPosition?: "top" | "bottom" | "left" | "right" //Position of the tooltip
  icon: IconDefinition //Icon
  isColorActive?: boolean //Color is active and not cta
  isOutlineColor?: boolean //Color only for border and text
  isFat?: boolean //Fat button primary
  isInactive?: boolean //Is the button inactive
  isPrimary?: boolean //Is the button a call to action
  isRounded?: boolean //For rounded btn
  isSmall?: boolean //Reduce icon and button size
  onAction?: Function //Clic on item of action menu
  onClick?: Function //Action on click
  plus?: boolean //Show plus icon
}

type Props = StateProps & OwnProps

function ListButton(props: Props) {
  //Open context menu of actions
  const [openActions, setOpenActions] = useState(false)

  //Action on clic
  function click(e) {
    e.stopPropagation()

    if (props.actions) {
      setOpenActions(true)
    }

    if (props.onClick) {
      props.onClick()
    }
  }

  //Clic on action
  function clickAction(actionId) {
    setOpenActions(false)
    if (props.onAction) {
      props.onAction(actionId)
    }
  }

  function getClassName() {
    let className = "list-button grey-t"

    if (props.isInactive) {
      className += " list-button-inactive"
    }
    if (props.isRounded) {
      className += " rounded-full"
    }
    return className
  }

  //Style
  //Color CTA if primary
  function getStyle() {
    const defaultColor = props.isColorActive ? props._session.accountColors.active : props._session.accountColors.cta
    let backgroundColor
    let color
    let border

    if (props.color) {
      if (props.isOutlineColor) {
        color = props.color
        border = `1px solid ${props.color}`
      } else {
        backgroundColor = props.color
        color = "white"
      }
    } else if (props.isFat) {
      backgroundColor = defaultColor
      color = "white"
    } else if (props.isPrimary) {
      color = defaultColor
    }

    return {
      backgroundColor,
      color,
      border,
      ...(props.isSmall ? { width: 28, fontSize: 12, padding: "2px 0" } : {})
    }
  }

  return (
    <div className="rel">
      {props.dot && (
        <div
          className={
            "abs " +
            (props.isSmall ? "list-button-dot-small" : "list-button-dot") +
            " " +
            (props.dotColor ? props.dotColor : "red")
          }
          style={props.dotOffsetY ? { transform: `translateY(${props.dotOffsetY}px)` } : undefined}
        />
      )}

      <Tooltip text={props.text} position={props.tooltipPosition} usePortal>
        <button className={getClassName()} onClick={click} style={getStyle()}>
          <FontAwesomeIcon
            icon={props.icon}
            style={props.isSmall ? { fontSize: 12, width: 12, height: 12 } : undefined}
          />
          {props.plus && <span className="ml-1 font-bold">+</span>}
        </button>
      </Tooltip>

      <div className="rel dark-t">
        {openActions && props.actions && (
          <ActionsMenu
            actions={props.actions}
            positionBottom={props.actionsPositionBottom}
            positionRight
            onClose={() => setOpenActions(false)}
            onSelect={clickAction}
          />
        )}
      </div>
    </div>
  )
}

const mapStateToProps = (state) => ({
  _session: state._session
})

export default connect(mapStateToProps)(ListButton)
